/**
 *
 * @returns Windows サポート終了OSのお知らせページのJSX Element
 */
interface WindowsSupportEndProps {
  softName: string;
}

export const WindowsSupportEndText: React.FC<WindowsSupportEndProps> = ({
  softName,
}) => {
  return (
    <div>
      <div className="c-section">
        <h2 className="p-heading-2">Windowsの動作保証終了OSについて</h2>
        <p className="c-text">
          マイクロソフトは、2023年1月10日にWindows8.1の製品サポートを終了しました。
          これに伴い、{softName}もWindows
          8.1およびそれ以前のOSでの動作保証を終了いたします。
          動作保証終了後も、これらのOSで引き続きご使用いただくことは可能ですが、
          セキュリティー上の問題が発生する可能性がありますので、
          新しいOSにバージョンアップしてご使用ください。
        </p>
      </div>
    </div>
  );
};
